import React, { useState } from 'react'

import Button from '~/components/button'
import Modal from '~/components/modal'
import { i18n } from '~/i18n'

import type { Props as ButtonProps } from '~/components/button'

type Props = Omit<ButtonProps, 'to'> & {
  onClick: (e: React.SyntheticEvent) => void
  confirmationTitle?: string
  confirmationText?: string
}

export default function ButtonWithConfirmation({
  confirmationTitle = i18n.t('administration.confirmations.are_you_sure'),
  confirmationText = i18n.t('administration.confirmations.are_you_sure'),
  onClick,
  ...restProps
}: Props) {
  const [isConfirming, setIsConfirming] = useState(false)

  return (
    <>
      <Button {...restProps} onClick={() => setIsConfirming(true)} />
      {isConfirming && (
        <Modal
          title={confirmationTitle}
          onClose={() => setIsConfirming(false)}
          actions={{
            primary: {
              text: i18n.t('administration.confirmation_modal.confirm'),
              onClick: (e) => {
                setIsConfirming(false)
                onClick(e)
              },
            },
            secondary: {
              text: i18n.t('administration.confirmation_modal.cancel'),
              onClick: () => setIsConfirming(false),
            },
          }}
        >
          {confirmationText}
        </Modal>
      )}
    </>
  )
}
